/**
 * `aria-labelledby` as spreadable props, empty without an id. Base UI merges
 * explicit props over its own, so an explicit `undefined` would erase the id
 * a `Field.Label` or `Fieldset.Legend` wired onto the control.
 */
export const ariaLabelledbyProps = (
    ariaLabelledby: string | undefined,
): { "aria-labelledby"?: string } =>
    ariaLabelledby === undefined ? {} : { "aria-labelledby": ariaLabelledby };
